import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LayoutActionButton {
    label?: string;
    disabled?: boolean;
    hidden?: boolean;
    onClick?: () => void;
}

interface LayoutState {
    actionButton: LayoutActionButton | null;
}

const initialState: LayoutState = {
    actionButton: null,
};

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setActionButton: (state, action: PayloadAction<LayoutActionButton | null>) => {
            if (action.payload) {
                state.actionButton = {
                    ...action.payload,
                    hidden: action.payload.hidden ?? true,
                };
            } else {
                state.actionButton = null;
            }
        },
    },
});

export const { setActionButton } = layoutSlice.actions;
export default layoutSlice.reducer;
